module.exports = __webpack_public_path__ + "img/bussiness_mobile_yywl1.699a63e3.png";